//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "approval-sup-deal",
  components:{
    divSpan
  },
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      listType:'',
      config:{
        title:'资料审核',
        url:'api/sup-modify/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'供应商编号/名称',
          searchCondition:'key',
          rules:[{field: "supplier.supplierCode-supplier.supplierName", option: "LIKE_ANYWHERE"}]
        },
      },
      configTodo:{
        title:'资料审核',
        url:'api/sup-modify/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'供应商编号/名称',
          searchCondition:'key',
          rules:[{field: "supplier.supplierCode-supplier.supplierName", option: "LIKE_ANYWHERE"}]
        },
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/supModify').then(data=>{
        this.config.workflowSearchBean={
          workflowId:data.workflowType
        };
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
        };
        this.$refs.header.getlist();
      })
    },
    goDetail(item){
      this.$router.push('/workflow/' + item.requestId + `?component=SupInfoApproveComponent&orderNo=No.${item.docNo}&title=资料变更`);
    }
  },
  mounted(){
    this.listType = this.$route.params.listType;
    this.init();
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/approval/approval-sup-list.vue